import { filterStoreRepo } from 'components/Filters/FilterStore'
import FilterModal, {
  FilterGroup,
} from 'components/Filters/components/FilterModal'
import { FilterIdentifier } from 'models/saved_view'
import { SelectFilter } from 'components/Filters/fields/SelectFilter'
import { DateRangeFilterWithPresets } from 'components/Filters/fields/DateRangeFilterWithPresets'
import useApiService from 'services/api'

const STATUS_OPTIONS = [
  { value: 'scheduled', label: 'Scheduled' },
  { value: 'sent', label: 'Sent' },
  { value: 'failed', label: 'Failed' },
  { value: 'deleted', label: 'Deleted' },
  { value: 'paused', label: 'Paused' },
  { value: 'active', label: 'Active' },
  { value: 'ended', label: 'Ended' },
]

const REMINDER_TYPE_OPTIONS = [
  { value: 'one_off', label: 'One-time' },
  { value: 'daily', label: 'Daily' },
  { value: 'weekly', label: 'Weekly' },
  { value: 'monthly', label: 'Monthly' },
  { value: 'quarterly', label: 'Quarterly' },
  { value: 'annually', label: 'Annually' },
  { value: 'custom', label: 'Custom' },
]

export function RemindersFilterset({
  filterIdentifier,
}: {
  filterIdentifier: FilterIdentifier
}) {
  const api = useApiService()
  const remindersFilterStore = filterStoreRepo.getStore(filterIdentifier)

  const { data: userOptions } = api.useGetUserOptions({ onlyActive: false })

  return (
    <FilterModal identifier={filterIdentifier} store={remindersFilterStore}>
      <div className={'mt-3 mb-2'}>
        <p className={'text-md font-medium mb-2'}>Reminder Status</p>
        <div className="w-full">
          <SelectFilter
            title="Status"
            filterKey="status"
            filterStore={remindersFilterStore}
            options={STATUS_OPTIONS}
          />
        </div>
      </div>

      <div className={'mt-3 mb-2'}>
        <p className={'text-md font-medium mb-2'}>Reminder Frequency</p>
        <div className="w-full">
          <SelectFilter
            title="Type"
            filterKey="reminder_type"
            filterStore={remindersFilterStore}
            options={REMINDER_TYPE_OPTIONS}
          />
        </div>
      </div>

      <div className={'mt-3 mb-2'}>
        <p className={'text-md font-medium mb-2'}>People</p>
        <div className="w-full space-y-2">
          <SelectFilter
            title="Created By"
            filterKey="created_by"
            filterStore={remindersFilterStore}
            options={userOptions as any}
          />
          <SelectFilter
            title="Recipient"
            filterKey="recipient"
            filterStore={remindersFilterStore}
            options={userOptions as any}
          />
        </div>
      </div>

      <FilterGroup
        title="Date Filters"
        className="!grid-cols-2 !lg:grid-cols-2 !xl:grid-cols-2"
      >
        <DateRangeFilterWithPresets
          title="Date Scheduled"
          filterKey="run_at"
          filterStore={remindersFilterStore}
        />
        <DateRangeFilterWithPresets
          title="Date Created"
          filterKey="created"
          filterStore={remindersFilterStore}
        />
        <DateRangeFilterWithPresets
          title="Date Sent"
          filterKey="last_sent_at"
          filterStore={remindersFilterStore}
        />
        <DateRangeFilterWithPresets
          title="Date Deleted"
          filterKey="deleted_at"
          filterStore={remindersFilterStore}
        />
      </FilterGroup>
    </FilterModal>
  )
}
